import styled from "styled-components";
export const StyledCategoryFilter = styled.span``;

export const StyledPopoverContainer = styled.div`
  padding: var(--lib-default-spacing);
  overflow-y: auto;
  max-height: 50vh;

  .filter-helper-text {
    display: block;
    margin-bottom: var(--lib-default-spacing);
    color: #252525;
    font-weight: 600;
    font-size: var(--lib-text-size-0);
  }

  .filter-status-text {
    display: block;
    margin-bottom: var(--lib-default-spacing);
    font-size: var(--lib-text-size-0);
    font-weight: 600;
  }

  .filter-status-warning {
    color: #df333f;
  }

  .filter-status-info {
    color: #252525;
  }
`;

// Select All, Close buttons
export const StyledPopoverButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const StyledCFRow = styled.div`
  display: flex;
  gap: 0.1rem;
  align-items: start;

  .info-link-wrapper {
    font-size: var(--calcite-font-size--1);
  }

  .popover-content {
    font-size: var(--calcite-font-size--1);
    padding: 0.5rem;
  }
`;
